import { Box, Typography, List, ListItem, ListItemIcon, ListItemText, Button } from "@mui/material";
import React from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useNavigate } from "react-router-dom";
import itImage from "../../images/itsection.jpg";


const Benefits = () => {
  const navigate = useNavigate()
  return (
    <>
      {/* Hero Section */}
      {/* <Box id="about-section"
        sx={{
          padding: "80px 50px",
          background: "linear-gradient(135deg, #CB6211FF 0%, #FCB425FF 100%)",
          color: "#fff",
          textAlign: "center",
        }}
      >
        <Typography variant="h2" sx={{ fontWeight: "bold", marginBottom: "20px" }}>
          Yoga for Your Health
        </Typography>
        <Typography variant="h6" sx={{ lineHeight: "1.8", marginBottom: "30px" }}>
          Regular practice of yoga helps you say goodbye to doctors, medicines, and hospitals. Yoga 
          is the master key to joy, peace, and a healthy life.
        </Typography>
        <Button
          onClick={()=>navigate('/blogs')}
          variant="contained"
          sx={{
            backgroundColor: "#fff",
            color: "#6a11cb",
            fontWeight: "bold",
            padding: "10px 20px",
            borderRadius: "20px",
            ":hover": { backgroundColor: "#ddd" },
          }}
        >
          Learn More
        </Button>
      </Box> */}

      {/* Main Content Section */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "center",
          padding: "50px",
          gap: "30px",
        }}
      >
        {/* Left Content: Boost Productivity */}
        <Box
          sx={{
            width: { xs: "100%", md: "50%" },
            padding: "20px",
          }}
        >
          <Typography
            variant="h4"
            sx={{ fontWeight: "bold", marginBottom: "20px", color: "#6a11cb" }}
          >
            Boost Productivity & Well-Being in Your Workplace
          </Typography>
          <Typography variant="body1" sx={{ lineHeight: "1.8", marginBottom: "20px" }}>
            20-Minute Yoga & Meditation Session – Designed for IT Companies
          </Typography>
          <List>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon sx={{ color: "#6a11cb" }} />
              </ListItemIcon>
              <ListItemText primary="Stress and burnout from long hours in front of screens?" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon sx={{ color: "#6a11cb" }} />
              </ListItemIcon>
              <ListItemText primary="Back and neck pain caused by poor posture?" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon sx={{ color: "#6a11cb" }} />
              </ListItemIcon>
              <ListItemText primary="Mental fatigue and reduced focus?" />
            </ListItem>
          </List>
        </Box>

         <Box component="img" src={itImage} sx={{width:"600px",height:"400px",borderRadius:"20px"}}/>

         
        
      </Box>

      {/* What We Offer Section */}
      <Box sx={{ padding: "50px", background: "#f9f9f9" }}>
        <Typography variant="h4" sx={{ fontWeight: "bold", marginBottom: "20px", textAlign: "center" }}>
          What We Offer
        </Typography>

        {/* Side-by-Side Content */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: "30px",
            alignItems: "flex-start",
          }}
        >
          {/* Yoga Section */}
          <Box sx={{ flex: 1 }}>
            <Typography variant="h5" sx={{ fontWeight: "bold", marginBottom: "10px", color: "#6a11cb" }}>
              10 Minutes of Desk-Friendly Yoga
            </Typography>
            <List>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon sx={{ color: "#6a11cb" }} />
                </ListItemIcon>
                <ListItemText primary="Stretch & Relieve Tension: Simple neck rolls, shoulder stretches, and spinal twists." />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon sx={{ color: "#6a11cb" }} />
                </ListItemIcon>
                <ListItemText primary="Rejuvenate & Energize: Gentle poses like Forward Bends and Chest Openers to ease fatigue." />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon sx={{ color: "#6a11cb" }} />
                </ListItemIcon>
                <ListItemText primary="Improve Posture: Techniques to counteract slouching and desk strain." />
              </ListItem>
            </List>
          </Box>

          {/* Meditation Section */}
          <Box sx={{ flex: 1 }}>
            <Typography variant="h5" sx={{ fontWeight: "bold", marginBottom: "10px", color: "#6a11cb" }}>
              10 Minutes of Guided Meditation
            </Typography>
            <List>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon sx={{ color: "#6a11cb" }} />
                </ListItemIcon>
                <ListItemText primary="Stress Reduction: Breathing techniques to relax the mind." />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon sx={{ color: "#6a11cb" }} />
                </ListItemIcon>
                <ListItemText primary="Enhanced Focus: Mindfulness practices to improve clarity and efficiency." />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon sx={{ color: "#6a11cb" }} />
                </ListItemIcon>
                <ListItemText primary="Better Mental Health: A calming body scan to release mental and physical stress." />
              </ListItem>
            </List>
          </Box>
        </Box>
      </Box>

      {/* Closing Section */}
      <Box
        sx={{
          padding: "50px",
          background: "linear-gradient(135deg, #CB7111FF 0%, #FC8625FF 100%)",
          color: "#fff",
          textAlign: "center",
        }}
      >
        <Typography variant="h4" sx={{ fontWeight: "bold", marginBottom: "20px" }}>
          Why IT Companies Choose Us
        </Typography>
        <List sx={{ display: "inline-block", textAlign: "left", margin: "0 auto" }}>
          <ListItem>
            <CheckCircleIcon sx={{ marginRight: "10px", color: "#fff" }} />
            Custom-Tailored Sessions: Designed specifically for professionals who spend long hours seated.
          </ListItem>
          <ListItem>
            <CheckCircleIcon sx={{ marginRight: "10px", color: "#fff" }} />
            Time-Efficient: Just 20 minutes – perfect for a break or wellness hour.
          </ListItem>
          <ListItem>
            <CheckCircleIcon sx={{ marginRight: "10px", color: "#fff" }} />
            No Equipment Needed: Can be done at desks or in small spaces.
          </ListItem>
          <ListItem>
            <CheckCircleIcon sx={{ marginRight: "10px", color: "#fff" }} />
            Boosts Morale & Productivity: Happier, healthier employees perform better!
          </ListItem>
        </List>
      </Box>
    </>
  );
};

export default Benefits;
